import React from 'react';
import { Grid, List } from 'semantic-ui-react';
import { ButtonLink, Modal } from 'dyl-components';
import { Link } from 'react-router-dom';
import OptionsAreaModalContent from './OptionsAreaModalContent';

import './OptionsArea.scss';

const OptionsArea = ({ onToggleModal }) => (
    <Grid>
        <Grid.Row columns={2}>
            <Grid.Column>
                <List className="OptionsAreaList" size='large'>
                    <List.Item>
                        <List.Header as={ButtonLink} onClick={() => { onToggleModal('locations') }}>Assign Locations</List.Header>
                        <List.Content>Match DYL Users to locations in QQCatalyst</List.Content>
                    </List.Item>
                    <List.Item>
                        <List.Header as={ButtonLink} onClick={() => { onToggleModal('users') }}>User Assign</List.Header>
                        <List.Content>Match DYL Users to users in QQCatalyst</List.Content>
                    </List.Item>
                    
                </List>
            </Grid.Column>
            <Grid.Column>
                <List className="OptionsAreaList" size='large'>
                    <List.Item>
                        <List.Header as={ButtonLink} onClick={() => { onToggleModal('options') }}>Options</List.Header>
                        <List.Content>Configure options.</List.Content>
                    </List.Item>
                    <List.Item>
                        <List.Header as={Link} to='/reports/crm_activity'>Activity Log</List.Header>
                        <List.Content>View report of all CRM activity.</List.Content>
                    </List.Item>
                </List>
            </Grid.Column>
        </Grid.Row>
    </Grid>
);

class OptionsAreaContainer extends React.Component {
    state = {
        activeModal: '',
        modalState: {
            unassignedUsers: []
        }
    }

    onToggleModal = (modalName) => {
        this.setState({ activeModal: modalName });
    }

    onClose = () => {
        this.setState({ activeModal: '' });
    }

    render() {
        return (
            <React.Fragment>
                <OptionsArea 
                    onToggleModal={this.onToggleModal}
                />
                <Modal open={this.state.activeModal} onClose={this.onClose} size='small'>
                    <OptionsAreaModalContent 
                        modalName={this.state.activeModal} 
                        onClose={this.onClose}
                        {...this.state.modalState}
                    />
                </Modal>
            </React.Fragment>
        )
    }
}

export default OptionsAreaContainer;
